import { Teacher, User } from '../types/api';

// 쿠키 유틸리티 함수들
export const cookieAuth = {
  // 사용자 정보를 안전한 쿠키에 저장
  setUserInfo: (userInfo: User | Teacher, userType: 'user' | 'teacher') => {
    try {
      const userData = {
        ...userInfo,
        userType,
        timestamp: Date.now()
      };

      // HTTPS에서 secure 쿠키로 저장 (7일 만료)
      const cookieValue = encodeURIComponent(JSON.stringify(userData));
      const expires = new Date(Date.now() + 7 * 24 * 60 * 60 * 1000); // 7일

      document.cookie = `dreamdrums_user=${cookieValue}; expires=${expires.toUTCString()}; path=/; secure; samesite=strict`;
    } catch {
      // 사용자 정보 저장 실패
    }
  },

  // 쿠키에서 사용자 정보 가져오기
  getUserInfo: (): { userInfo: User | Teacher; userType: 'user' | 'teacher' } | null => {
    try {
      const cookies = document.cookie.split(';');
      const userCookie = cookies.find(cookie =>
        cookie.trim().startsWith('dreamdrums_user=')
      );

      if (!userCookie) return null;

      const cookieValue = userCookie.split('=')[1];
      const userData = JSON.parse(decodeURIComponent(cookieValue));

      // 타임스탬프 확인 (7일 초과시 무효)
      if (userData.timestamp && Date.now() - userData.timestamp > 7 * 24 * 60 * 60 * 1000) {
        cookieAuth.clearUserInfo();
        return null;
      }

      const { userType, timestamp, ...userInfo } = userData;
      return { userInfo, userType };
    } catch {
      // 사용자 정보 읽기 실패
      return null;
    }
  },

  // 사용자 정보 쿠키 삭제
  clearUserInfo: () => {
    document.cookie = 'dreamdrums_user=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; secure; samesite=strict';
  },

  // 인증 토큰 쿠키 삭제 (accessToken, refreshToken)
  clearAuthTokens: () => {
    document.cookie = 'accessToken=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    document.cookie = 'refreshToken=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
  },

  // 모든 인증 관련 쿠키 삭제 (로그아웃 시 사용)
  clearAll: () => {
    cookieAuth.clearUserInfo();
    cookieAuth.clearAuthTokens();
  },

  // 로그인 상태 확인
  isAuthenticated: (): boolean => {
    return cookieAuth.getUserInfo() !== null;
  },

  // 사용자 타입 확인
  getUserType: (): 'user' | 'teacher' | null => {
    const userData = cookieAuth.getUserInfo();
    return userData ? userData.userType : null;
  },

  // 현재 사용자 ID 가져오기
  getCurrentUserId: (): string | number | null => {
    const userData = cookieAuth.getUserInfo();
    if (!userData) return null;

    // User 타입인지 Teacher 타입인지 확인해서 적절한 ID 반환
    if (userData.userType === 'teacher') {
      return (userData.userInfo as Teacher).teacherId;
    } else {
      return (userData.userInfo as User).userId;
    }
  }
};

export default cookieAuth;